import {
  ContactBlock,
  FooterBlocs,
  FooterContainer,
  FooterIconCircle,
  FooterIconSocial,
  FooterPhones,
  FooterSecondText,
  FooterText,
  FooterTitle,
  MainText
} from "./styled";
import point from "./../../images/point-images/point.png";
import phone from "./../../images/point-images/phone.png";
import mail from "./../../images/point-images/mail.png";
import inst from "./../../images/social/inst.png";
import fb from "./../../images/social/fb.png";
import tg from "./../../images/social/tg.png";
import {Link} from "react-router-dom";
import {routes} from './../../shared/routes/routes'

export const Footer = () => {
  return <FooterContainer>
    <FooterBlocs>
      <FooterTitle>Школа "Мечта"</FooterTitle>
      <ContactBlock>
        <FooterIconCircle>
          <img src={point} alt="" />
        </FooterIconCircle>
        <FooterText>
          4245 Decarie Blvd, Montreal, QC H4A 3K4
        </FooterText>
      </ContactBlock>

      <ContactBlock>
        <FooterIconSocial>
          <a href="https://www.instagram.com/mechtamtl" target="_blank" rel="noreferrer">
            <img src={inst} alt="Instagram" />
          </a>
        </FooterIconSocial>
        <FooterIconSocial>
          <a href="https://www.facebook.com/centermechta/" target="_blank" rel="noreferrer">
            <img src={fb} alt="Facebook" />
          </a>
        </FooterIconSocial>
        <FooterIconSocial>
          <a href="https://t.me/russian_school_mechta" target="_blank" rel="noreferrer">
            <img src={tg} alt="Telegram" />
          </a>
        </FooterIconSocial>
      </ContactBlock>

    </FooterBlocs>
    <FooterBlocs>
      <FooterSecondText>О нас</FooterSecondText>
      <MainText>
        <Link to={routes.about}>
        Наша история
        </Link>
      </MainText>
      <MainText>
        <Link to={routes.onlyNews}>
        Новости
        </Link>
      </MainText>
      <MainText><Link to={routes.studiesAnd}>
        Студии и кружки
      </Link></MainText>
      <MainText><Link to={routes.lap}>
        Психолог и Логопед
      </Link></MainText>
    </FooterBlocs>
    <FooterBlocs>
      <FooterSecondText>Расписание</FooterSecondText>
      <MainText>
        <Link to={routes.raspisaniePodgotovka}>
          Подготовительные классы
        </Link>
        </MainText>
      <MainText>
        <Link to={routes.raspisanieChild}>
          Начальная школа
        </Link></MainText>
      <MainText>
        <Link to={routes.raspisanieHight}>
          Средняя и старшая школа
        </Link>
      </MainText>
      <MainText>
        <Link to={routes.raspisanie}>
          Расписание студий
        </Link>
      </MainText>
    </FooterBlocs>
    <FooterBlocs>
      <FooterSecondText>Контакты</FooterSecondText>
      <ContactBlock>
        <FooterIconCircle>
          <img src={mail} alt="" />
        </FooterIconCircle>
        <FooterText>director@mechtacenter.org</FooterText>
      </ContactBlock>
      <ContactBlock>
        <FooterIconCircle>
          <img src={phone} alt="" />
        </FooterIconCircle>
        <FooterPhones>
          <p>+1(514)772-50-12</p>
          <p>+1(514)795-46-77</p>
          <p>+1(514)712-50-12</p>
        </FooterPhones>
      </ContactBlock>
    </FooterBlocs>
  </FooterContainer>
}
